import React from "react";
import { makeStyles } from "tss-react/mui";
import { Tag } from "component/shared/tag";
import { statusConfig, TextingDisplayStatus } from "shared/texting-status";
import { StatusIcon } from "../status-icon";

// Figma spaces the chip's icon 8px (spacing/xs) from its label; the shared Tag uses 4.
const useStyles = makeStyles()((theme) => ({
	tag: {
		"&&": {
			gap: theme.spacing(1),
		},
	},
}));

interface Props {
	status: TextingDisplayStatus;
}

export const StatusTag: React.FC<Props> = ({ status }) => {
	const { classes } = useStyles();
	const config = statusConfig(status);
	return <Tag label={config.label} variant={config.tone} className={classes.tag} icon={<StatusIcon icon={config.icon} tag />} />;
};
